module.exports = __webpack_public_path__ + "images/275b620e65c1de9fbec49a0caad6806d.svg";